// extracted by mini-css-extract-plugin
export default {"container":"PowerOptions_container__mEy6H","power_option":"PowerOptions_power_option__Vixpb"};